import * as z from "zod";

export const sendPayouts = {
  name: "sendPayouts" as const,
  input: z.any(),
  output: z.object({ success: z.boolean(), transferIds: z.array(z.string()) }),
};
